<script lang="ts">
  import { flip } from "svelte/animate";
  import { fly } from "svelte/transition";
  import { backOut } from "svelte/easing";
  import { ui } from "../lib/stores/ui.svelte.js";
  import Icon from "./Icon.svelte";
</script>

<div class="toasts" aria-live="polite">
  {#each ui.toasts as toast (toast.id)}
    <div
      class="toast {toast.tone}"
      animate:flip={{ duration: 260 }}
      in:fly={{ y: -24, duration: 380, easing: backOut }}
      out:fly={{ y: -12, duration: 220 }}
      role={toast.tone === "error" ? "alert" : "status"}
    >
      <span class="badge"
        ><Icon name={toast.tone === "error" ? "close" : "check"} size={14} stroke={3} /></span
      >
      <span>{toast.message}</span>
      {#if toast.action}
        <button
          type="button"
          class="action"
          onclick={() => {
            toast.action?.run();
            ui.dismiss(toast.id);
          }}>{toast.action.label}</button
        >
      {/if}
    </div>
  {/each}
</div>

<style>
  .toasts {
    position: fixed;
    top: calc(14px + var(--safe-top));
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    z-index: var(--z-toast);
    pointer-events: none;
    width: min(92vw, 520px);
  }
  .toast {
    pointer-events: auto;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 18px 10px 10px;
    border-radius: var(--r-pill);
    background: var(--text);
    color: var(--text-on-light);
    font-weight: 700;
    font-size: 14px;
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.5);
  }
  .badge {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--accent-3);
    color: var(--on-accent-3);
    flex: 0 0 24px;
  }
  .info .badge {
    background: var(--accent);
    color: var(--on-accent);
  }
  .error .badge {
    background: var(--danger);
    color: #2a0505;
  }
  .action {
    margin-left: 6px;
    font-weight: 800;
    color: #1d4fc4;
  }
</style>
